import React, { useEffect, useRef, useState } from "react";
import { DropBox, Tag } from "../../../components";
import { getLanguage } from "../../../utils/environment";
import { useDispatch, useSelector } from "react-redux";
import { getAllTags } from "../../Tags/service/tags.service";
import { clearNewTag, setTagsList } from "../../Tags/redux/actions";

const Index = ({ data, onChangeTag, tagList, selectedTagList }) => {
  const [selectList, setSelectList] = useState([]);
  const [formData, setFormData] = useState({
    tagName: {
      key: "tagName",
      label: "Tags",
      size: "lg",
      placeholder: "Select Tags",
      mainLayerStyles: " flex-column align-content-center mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const { isUpdateTagList, newTag } = useSelector(
    ({ tagsReducer }) => tagsReducer
  );
  const { selectNews } = useSelector(({ newsReducer }) => newsReducer);

  const dispatch = useDispatch();
  const prevLength = useRef(0);

  const fetchTags = async () => {
    const updateForm = { ...formData };
    updateForm.tagName.loading = true;
    updateForm["tagName"].elementConfig.options = [];
    const response = await getAllTags();
    if (response?.data) {
      let tagNameList = await syncTagName(response.data);
      updateForm["tagName"].elementConfig.options = tagNameList;
      updateForm.tagName.loading = false;
      dispatch(setTagsList(response.data));

      setFormData(updateForm);
    }
  };

  const syncTagName = async (res) => {
    let tagList = [];
    for (let tag of res) {
      const articleCount = tag.article_ids?.length || 0;
      tagList.push({
        id: tag.tag_id,
        key: `${tag.tag_name} (${articleCount})`,
        value: tag.tag_id,
        displayValue: `${tag.tag_name} (${articleCount})`,
      });
    }
    return tagList;
  };

  const onClickAddToList = (tag) => {
    let newList = [...selectList];
    let isExist = false;
    for (let index = 0; index < newList.length; index++) {
      if (newList[index]?.value === tag?.value) {
        isExist = true;
      }
    }
    if (!isExist) {
      newList.push(tag);
      setSelectList(newList);
    }
  };

  useEffect(() => {
    if (formData.tagName.elementConfig.options.length === 0) {
      fetchTags();
    }
    setSelectList([]);
  }, []);

  useEffect(() => {
    if (onChangeTag && selectList) {
      // get the selected tags
      const selectedTags = selectList?.map((tag) => tag.value);
      onChangeTag(selectedTags);
    }
  }, [selectList]);

  useEffect(() => {
    if (isUpdateTagList) {
      fetchTags();
    }
  }, [isUpdateTagList]);

  useEffect(() => {
    if (!Array.isArray(tagList) || tagList.length === 0) {
      setSelectList([]);
      const resetForm = { ...formData };
      resetForm.tagName.value = "";
      setFormData(resetForm);
      return;
    }

    const updateFormCopy = { ...formData };
    const newList = [...selectList];

    // Use a Set to track already-added values
    const existingValues = new Set(newList.map((item) => item?.value));

    let hasNew = false;

    for (let tag of tagList) {
      if (!existingValues.has(tag)) {
        const tagData = updateFormCopy.tagName.elementConfig.options.find(
          (option) => option.value === tag
        );
        if (tagData) {
          newList.push(tagData);
          existingValues.add(tag); // avoid adding again
          hasNew = true;
        }
      }
    }

    if (hasNew && Array.isArray(tagList) && tagList.length !== 0) {
      setSelectList(newList);
    }
  }, [tagList]);

  useEffect(() => {
    if (!Array.isArray(selectNews?.tags) || selectNews?.tags?.length === 0) {
      return;
    }
    const newList = [];
    const updateFormCopy = { ...formData };

    const existingValues = new Set(newList.map((item) => item?.value));

    let hasNew = false;

    for (let tag of selectNews?.tags || []) {
      if (!existingValues.has(tag)) {
        const tagData = updateFormCopy.tagName.elementConfig.options.find(
          (option) => option.value === tag
        );
        if (tagData) {
          newList.push(tagData);
          existingValues.add(tag); // avoid adding again
          hasNew = true;
        }
      }
    }

    if (
      hasNew &&
      Array.isArray(selectNews?.tags) &&
      selectNews?.tags?.length !== 0
    ) {
      setSelectList(newList);
    }
    // dispatch(clearNewTag());
  }, [selectNews]);

  useEffect(() => {
    const newList = [...selectList];

    const existingValues = new Set(newList.map((item) => item?.value));

    let hasNew = false;

    if (!existingValues.has(newTag.tag_id)) {
      if (newTag?.tag_id) {
        newList.push({
          id: newTag.tag_id,
          key: newTag.tag_name + ` (${newTag.article_ids?.length || 0})`,
          value: newTag.tag_id,
          displayValue:
            newTag.tag_name + ` (${newTag.article_ids?.length || 0})`,
        });
        existingValues.add(newTag.tag_id); // avoid adding again
        hasNew = true;
      }
    }

    if (hasNew && Array.isArray(newList) && newList.length !== 0) {
      setSelectList(newList);
    }
    // dispatch(clearNewTag());
  }, [newTag]);

  const updateNewsForm = { ...formData };

  return (
    <>
      <DropBox
        data={updateNewsForm.tagName}
        onChange={(e) => {
          const updateForm = { ...formData };
          updateForm["tagName"].value = e;
          setFormData(updateForm);

          const selectedTag = updateNewsForm.tagName.elementConfig.options.find(
            (tag) => tag.value === e
          );
          onClickAddToList(selectedTag);
        }}
      />
      <div className="d-flex flex-row flex-wrap">
        {selectList?.length > 0 &&
          selectList.map((tag) => (
            <div className="ml-2">
              <Tag
                key={tag.id}
                data={{
                  tagName: tag?.displayValue,
                  tagIcon: "",
                  type: "primary",
                  isIcon: true,
                }}
                onClick={() => {
                  const newList = selectList.filter(
                    (item) => item.id !== tag?.id
                  );
                  setSelectList(newList);
                }}
              />
            </div>
          ))}
      </div>
    </>
  );
};

export default Index;
